export default class Parser {
  data = {};

  url = '';

  exclude = [];

  parseToUrl(data) {
    this.data = data;
    this.setDataToURL();

    return this;
  }

  parseToData(url) {
    this.url = url;
    this.getURLData();

    return this;
  }

  getURLData() {
    const arr = this.url.split('&');
    const newData = {};
    arr.forEach((item) => {
      const [key, val] = item.split('=');
      newData[key] = val;
    });
    this.data = newData;
  }

  setDataToURL() {
    const arr = Object.entries(this.data).map(([key, value]) => `${key}=${value}`);
    this.url = arr.join('&');
  }

  getResult() {
    return [this.url, this.data, this.exclude];
  }
}
